import { colors } from '@fitpet/constants-global'
import { FitpetIcon } from '@fitpet/ui/components'
import clsx from 'clsx'
import styles from '@/components/domains/product-detail/product-detail-challenge-tooltip.module.css'
import ROUTES from '@/constants/legacy/constRoutes'
import { useCustomRouter } from '@/containers/hooks'
import { Bridge } from '@/utils/bridge/bridge'
import appBridgeProvider from '@/utils/utilBridge'
import { isInApp } from '@/utils/utilCommon'

const getHealthHomeUrl = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:7001/play/home'
  }
  return ROUTES.PLAY.HOME
}

export const ProductDetailChallengeTooltip = () => {
  const router = useCustomRouter()

  const handleClickChallengeButton = () => {
    if (isInApp()) {
      appBridgeProvider((bridge: Bridge) => {
        bridge.goDeepLink('play', 'main')
      })
    } else {
      router.push(getHealthHomeUrl())
    }
  }

  return (
    <div className={styles.fixedBottomContainer}>
      <button
        className={clsx(styles.button, 'gray-black font-body3-bold')}
        type="button"
        onClick={handleClickChallengeButton}
      >
        챌린지 완료하고 더 저렴하게 구매하기
        <FitpetIcon icon="icChevronRight" size={20} color={colors.BLUE_500} />
      </button>
    </div>
  )
}
